<template>
  <div id="blend">
      <mycarousel></mycarousel>
      <div class="blend1 titleBox">
        <p class="title">专业混合应用开发，让您省心省力</p>
        <ul>
            <li v-for="(item,index) in blend1" :key="index" class="wow animate__animated animate__fadeInLeft">
              <img :src="item.icon" alt="">
              <div>
                  <p class="p1">{{item.title}}</p>
                  <p class="p2">{{item.subtitle}}</p>
              </div>
            </li>
        </ul>
      </div>
      <div class="blend2 titleBox">
        <p class="title">四大专业服务，全程为您保驾护航</p>
        <p class="subtitle">十年开发定制服务经验，更专业，更优质</p>
        <div class="blend2Box">
            <img src="@/assets/blend/blend1Img.png" alt="" class="img">
            <ul>
                <li v-for="(item,index) in blend2" :key="index" class="wow animate__animated animate__fadeInLeft">
                    <p class="p1"><img :src="item.icon" alt="">{{item.title}}</p>
                    <p class="p2">{{item.subtitle}}</p>
                </li>
            </ul>
        </div>
      </div>
      <div class="blend3 titleBox">
        <p class="title">完善的服务让您用的放心</p>
        <p class="subtitle">十年开发定制服务经验，更专业，更优质</p>
        <ul>
            <li v-for="(item,index) in blend3" :key="index" class="wow animate__animated animate__fadeInLeft">
              <img :src="item.icon" alt="">
              <p class="p1">{{item.title}}</p>
              <p class="p2">{{item.subtitle}}</p>
            </li>
        </ul>
      </div>
      <div class="blend4 titleBox">
        <p class="title">设计+搭建+售后一条龙高质量服务</p>
        <p class="subtitle">十年开发定制服务经验，更专业，更优质</p>
        <ul>
            <li v-for="(item,index) in blend4" :key="index" class="wow animate__animated animate__fadeInLeft">
              <img :src="item.icon" alt="">
              <p class="p1">{{item.title}}</p>
            </li>
        </ul>
      </div>
      <mytechnology></mytechnology>
  </div>
</template>

<script>
import mycarousel from  '@/components/carousel/carousel.vue'
import mytechnology from  '@/components/technology/technology.vue'
export default {
  name: "blend",
  components: {
    mycarousel,
    mytechnology
  },
  data(){
    return {
      blend1:[
        {
            icon:require('@/assets/blend/blend1icon1.png'),
            title:"成本较低",
            subtitle:"基础服务架构，项目投入成本低，利用所有可利用资源尽量让用户的成本降到最低"
        },
        {
            icon:require('@/assets/blend/blend1icon2.png'),
            title:"覆盖面广",
            subtitle:"线上线下互动、支持多样化企业服务，包涵APP、小程序和官网制作等等响应式布局"
        },
        {
            icon:require('@/assets/blend/blend1icon3.png'),
            title:"项目周期短",
            subtitle:"支持快速搭建，低投入和高收益，下单到出图三天之内搞定15天之内可交付项目"
        },
        {
            icon:require('@/assets/blend/blend1icon4.png'),
            title:"拓展性强",
            subtitle:"倚靠小易强大体系，拓展性强，易维护，可随时添加定制功能，满足您的需求"
        }
      ],
      blend2:[
        {
            icon:require('@/assets/blend/blend2icon1.png'),
            title:"IOS开发",
            subtitle:"商务沟通/需求调研/业务架构设计/可行性分析"
        },
        {
            icon:require('@/assets/blend/blend2icon2.png'),
            title:"安卓开发",
            subtitle:"难点攻关/架构设计/接口设计/数据库设计/框架搭建/技术文档编写"
        },
        {
            icon:require('@/assets/blend/blend2icon3.png'),
            title:"混合应用开发",
            subtitle:"商务沟通/需求调研/业务架构"
        },
        {
            icon:require('@/assets/blend/blend2icon4.png'),
            title:"H5应用开发",
            subtitle:"制定开发/管控进度/系统编码"
        }
      ],
      blend3:[
        {
            icon:require('@/assets/blend/blend3icon1.png'),
            title:"专业运营",
            subtitle:"十年专业运营让你的产品数据越来越好"
        },
        {
            icon:require('@/assets/blend/blend3icon2.png'),
            title:"快速制作",
            subtitle:"从下单到制作只需要15天快速搭建一个您想要的APP"
        },
        {
            icon:require('@/assets/blend/blend3icon3.png'),
            title:"优良团队",
            subtitle:"优秀团队经验丰富互联网大厂优秀合作团队"
        },
        {
            icon:require('@/assets/blend/blend3icon4.png'),
            title:"完善售后",
            subtitle:"售前-售中-售后360°全方位无死角服务"
        }
      ],
      blend4:[
        {
            icon:require('@/assets/blend/blend4icon1.png'),
            title:"专业运营",
        },
        {
            icon:require('@/assets/blend/blend4icon2.png'),
            title:"快速制作",
        },
        {
            icon:require('@/assets/blend/blend4icon3.png'),
            title:"优良团队",
        },
        {
            icon:require('@/assets/blend/blend4icon4.png'),
            title:"完善售后",
        }
      ]
    }
  }
}
</script>

<style lang="scss">
  :root {
    --web-max-width: 1920px;
    --web-min-width: 1300px;
  }
  .titleBox{
    .title{
      font-size: 28px;
      font-weight: 400;
      color: #333333;
      padding-top: 60px;
      text-align: center;
      margin-bottom: 12px;
    }
    .subtitle{
      font-size: 16px;
      font-weight: 400;
      color: #A2A5AC;
      text-align: center;
      margin-bottom: 60px;
    }
  }
  #blend{
    .blend1{
        ul{
            width: 1200px;
            margin:60px auto 0;
            display: flex;
            flex-wrap: wrap;
            li{
                display: flex;
                align-items: center;
                width: 580px;
                height: 188px;
                background: #FAFAFA;
                border-radius: 8px 8px 8px 8px;
                padding: 56px 44px;
                div{
                    .p1{
                        font-size: 24px;
                        font-weight: 400;
                        color: #333333;
                        margin-bottom: 16px;
                    }
                    .p2{
                        font-size: 14px;
                        font-weight: 400;
                        color: #333333;
                    }
                }
                img{
                    width: 76px;
                    margin-right: 44px;
                }
            }
            li:nth-child(-n+2){
                margin-bottom: 40px;
            }
            li:nth-child(2n+1){
                margin-right: 40px;
            }
        }
    }
    .blend2{
        margin-top: 84px;
        background-image: url("../../assets/blend/blend1Bg.png");
        background-size: cover;
        height: 720px;
        .img{
            width: 830px;
            display: block;
            margin:0 auto;
        }
        .blend2Box{
            width: 830px;
            margin:0 auto;
            position: relative;
        }
        li{
            position: absolute;
            width: 210px;
            height: 118px;
            background: #FFFFFF;
            box-shadow: 0px 2px 18px 1px rgba(152,152,152,0.1);
            border-radius: 4px 4px 4px 4px;
            padding:24px 16px;
            .p1{
                font-size: 20px;
                font-weight: 500;
                color: #333333;
                display: flex;
                align-items: center;
                margin-bottom: 9px;
                img{
                    width: 22px;
                    margin-right: 8px;
                }
            }
            .p2{
                font-size: 14px;
                font-weight: 400;
                color: #666666;
            }
        }
        li:nth-child(1){
            top: 15px;
            left: -84px;
        }
        li:nth-child(2){
            width: 257px;
            top: 51px;
            right: -123px;
        }
        li:nth-child(3){
            top: 270px;
            left: -62px;
        }
        li:nth-child(4){
            top: 311px;
            right: -54px;
        }
    }
    .blend3{
        ul{
            width: 1200px;
            margin:60px auto 0;
            display: flex;
            li{
                width: 268px;
                height: 368px;
                background: #FFFFFF;
                box-shadow: 0px 2px 18px 1px rgba(220,233,249,0.6);
                border-radius: 12px 12px 12px 12px;
                padding: 54px 50px;
                text-align: center;
                img{
                    width: 148px;
                }
                .p1{
                    font-size: 24px;
                    font-weight: 500;
                    color: #333333;
                    margin-bottom: 16px;
                }
                .p2{
                    font-size: 14px;
                    font-weight: 400;
                    color: #333333;
                }
            }
            li:nth-child(-n+3){
                margin-right: 43px;
            }
        }
    }
    .blend4{
        ul{
            width: 1200px;
            margin:60px auto 0;
            display: flex;
            justify-content: space-between;
            li{
                width: 120px;
                text-align: center;
                img{
                    width: 120px;
                    margin-bottom: 24px;
                }
                .p1{
                    font-size: 24px;
                    font-family: Source Han Sans SC-Regular, Source Han Sans SC;
                    font-weight: 400;
                    color: #333333;
                }
            }
            li:nth-child(-n+3){
                position: relative;
            }
            li:nth-child(-n+3)::after{
                content:"";
                display: block;
                width: 94px;
                height: 18px;
                background-image: url('../../assets/blend/go.png');
                position: absolute;
                top: 55px;
                right:-168px;
                background-size: 100% 100%;
            }
        }
    }
  }
</style>
